export default [
  {
    header: 'ClientPortal.SideMenu.Info',
  },
  {
    title: 'ClientPortal.SideMenu.Contact',
    route: 'contact',
    icon: 'Message',
  },
]
